import { summaryToHtml, summaryToPlainText } from './summary-markdown';

/**
 * Copie le résumé dans le presse-papiers en DEUX formats (texte brut + HTML) :
 * un champ texte reçoit un texte propre, un éditeur riche (mail, Notion, Docs)
 * garde le gras et les listes. Repli sur le texte brut seul quand `ClipboardItem`
 * n'existe pas (navigateur ancien, WebView). Renvoie `false` si rien n'a pu être copié.
 */
export async function copySummaryToClipboard(markdown: string): Promise<boolean> {
  const plain = summaryToPlainText(markdown);
  const html = summaryToHtml(markdown);

  try {
    if (typeof ClipboardItem !== 'undefined' && navigator.clipboard?.write) {
      await navigator.clipboard.write([
        new ClipboardItem({
          'text/plain': new Blob([plain], { type: 'text/plain' }),
          'text/html': new Blob([html], { type: 'text/html' }),
        }),
      ]);
      return true;
    }
  } catch {
    // ex. Safari refuse le format riche hors geste : on retente en texte brut.
  }

  try {
    await navigator.clipboard.writeText(plain);
    return true;
  } catch {
    return false;
  }
}
